import { textRoutesDefinitions } from '@/routes-definitions';

export const questionRoutes = [
  {
    path: textRoutesDefinitions.kfkV2.path,
    name: textRoutesDefinitions.kfkV2.name,
    component: () => import('./pages/KFKV2Page.vue')
  },
  {
    path: textRoutesDefinitions.bookScores.path,
    name: textRoutesDefinitions.bookScores.name,
    component: () => import('./pages/BookScoresPage.vue')
  },
  {
    path: textRoutesDefinitions.bookScoreByCourseCode.path,
    name: textRoutesDefinitions.bookScoreByCourseCode.name,
    component: () => import('./pages/BookScoreResultsPage.vue')
  },
  {
    path: textRoutesDefinitions.results.path,
    name: textRoutesDefinitions.results.name,
    component: () => import('./pages/ResultsPage.vue')
  },
  {
    path: textRoutesDefinitions.homeInitFailed.path,
    name: textRoutesDefinitions.homeInitFailed.name,
    component: () => import('./pages/HomeInitFailedPage.vue')
  }
];
